export default "__VITE_ASSET__2nchqmQQ__"